import { SVGProps, Ref, forwardRef } from 'react';

export const HumanWalkFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.051 11.27c.224.22.512.45.802.681l.455.364-.306 1.018-2.212 2.513a.451.451 0 0 1-.725-.528l1.604-2.651.323-1.457z"
                fill="currentColor"
            />
            <path
                d="M8.119 4.667a1.27 1.27 0 0 1 1.246 1.52l-.696 3.48 1.096 1.919c.118.206.177.31.217.421.04.112.06.23.098.464l.488 2.924a.52.52 0 0 1-1.01.235l-.89-2.963-2.065-1.653c-.617-.494-.926-.74-1.054-1.092-.128-.351-.05-.739.104-1.513l.35-1.742-1.667 1-.29 2.026a.357.357 0 0 1-.71-.05V7.436c0-.1 0-.15.003-.198.025-.352.189-.68.456-.912.035-.031.076-.061.156-.12l.357-.27a6.35 6.35 0 0 1 3.81-1.27"
                fill="currentColor"
            />
            <path d="M12.718 7.262a.375.375 0 0 1-.09.738h-2.403l.26-1.296z" fill="currentColor" />
            <path d="M8.336 0c1.5 0 2 1 2 2s-.5 2-2 2-2-1-2-2 .5-2 2-2" fill="currentColor" />
        </g>
    </svg>
));
HumanWalkFilledSize16Glyph.displayName = 'HumanWalkFilledSize16Glyph';
